import { MaybeRefOrGetter, computed, toValue } from 'vue'

import { useFeatureFlagStore } from '../featureFlagStore'

import { FeatureFlag } from '../types'

export function useFeatureFlags() {
  return useFeatureFlagStore()
}

export function useFeatureFlag(flag: MaybeRefOrGetter<FeatureFlag>) {
  const store = useFeatureFlagStore()
  return computed(() => store.isOn(toValue(flag)))
}
